export default __webpack_public_path__ + "media/images/lp/conversion-main-pc-a56f3bf3819bcc2c61b22f9927372b00.png";